/* global  dataLayer */
export const initAnalytics = userHash => {
  console.log('init', userHash)
}

export const PRODUCT_CODE_NOT_SET = 'not-set'

export const trackProductCode = productCode => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      productCode,
    })
  } else {
    console.log('trackProductCode', {
      productCode,
    })
  }
}

export const trackEvent = (action, category, value = '') => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      event: 'widget_event',
      action,
      category,
      value,
    })
  } else {
    console.log('trackEvent', {
      event: 'widget_event',
      action,
      category,
      value,
    })
  }
}

export const trackPageView = url => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push({
      PageView: url,
      event: 'PageView',
    })
  } else {
    console.log('trackPageView', {
      PageView: url,
      event: 'PageView',
    })
  }
}
